import { CardTokenizationError } from '~/services/modules/paymentGateway/tokenizeCard';
import { CARD_CHANGE_DEFAULT_ORG_ID } from '~/services/modules/cardChange';

/** Org do link (`?org=`) ou a org Aride. O GET do contrato não devolve a org. */
export function resolveCardChangeOrganization(orgFromLink: string | null | undefined) {
  const org = orgFromLink?.trim();
  return org ? org : CARD_CHANGE_DEFAULT_ORG_ID;
}

/**
 * Contrato inexistente (404 ou corpo sem contrato) vs. falha temporária (5xx, timeout, rede): só o primeiro é
 * «Não encontramos este contrato»; o segundo oferece «Tentar novamente». Compara pelo `name` para não depender
 * da classe do serviço (mockado nos testes).
 */
export function isCardChangeContractMissing(error: unknown): boolean {
  if ((error as ApiError)?.response?.status === 404) return true;
  return error instanceof Error && error.name === 'CardChangeContractNotFoundError';
}

type ApiError = { response?: { status?: number; data?: { notifications?: { message?: string }[] } } };

/**
 * Mensagem da falha para a tela de nova tentativa: a recusa do gateway na tokenização ou a mensagem de negócio
 * da API (4xx com `notifications`, mesmo padrão do `renew`). 5xx e rede ficam só com o texto padrão.
 */
export function getCardChangeFailureMessage(error: unknown): string | null {
  if (error instanceof CardTokenizationError) return error.message;
  const status = (error as ApiError)?.response?.status ?? 0;
  if (status < 400 || status >= 500) return null;
  return (error as ApiError).response?.data?.notifications?.[0]?.message ?? null;
}
